import { HighContrastMode, HighContrastModeDetector } from '@angular/cdk/a11y';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { WiadomosciFacade } from '@app/pages/wiadomosci/wiadomosci.facade';
import { AuthService } from '@services/auth.service';
import { UserStorageService } from '@services/user-local-storage.service';

const accessibilityFontSize = 'accessibility_font_size';
const hightContrast = 'accessibility_high_contrast_mode';
const fontSizes = ['s', 'm', 'l', 'xl', 'xxl'];

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Output() readonly showMobileMenu = new EventEmitter<void>();

  currentFontSize = 0;
  private isHighContrastEnabled = false;

  constructor(
    readonly authService: AuthService,
    readonly wiadomosciFacade: WiadomosciFacade,
    readonly highContrastModeDetector: HighContrastModeDetector,
    private readonly userStorage: UserStorageService,
  ) {
    const storedFontSize = this.userStorage.getItem(accessibilityFontSize, false);
    if (storedFontSize) {
      this.currentFontSize = Number(storedFontSize);
      this.documentClassList.add(`font-size--${fontSizes[this.currentFontSize]}`);
    }

    if (this.userStorage.getItem(hightContrast, false) === '1') {
      this.toggleContrast();
    }
  }

  get documentClassList(): DOMTokenList {
    return document.documentElement.classList;
  }

  get isWindowsHighContrastDisabled(): boolean {
    return this.highContrastModeDetector.getHighContrastMode() === HighContrastMode.NONE;
  }

  ngOnInit(): void {
    this.wiadomosciFacade.getNumberOfUnreadMessages();
  }

  toggleContrast(): void {
    this.isHighContrastEnabled = !this.isHighContrastEnabled;
    if (this.isHighContrastEnabled) {
      this.documentClassList.add('high-contrast-mode');
    } else {
      this.documentClassList.remove('high-contrast-mode');
    }

    this.userStorage.setItem(hightContrast, this.isHighContrastEnabled ? '1' : '0');
  }

  zoomIn(): void {
    this.documentClassList.remove(`font-size--${fontSizes[this.currentFontSize]}`);
    this.currentFontSize++;
    this.documentClassList.add(`font-size--${fontSizes[this.currentFontSize]}`);
    this.userStorage.setItem(accessibilityFontSize, this.currentFontSize.toString());
  }

  zoomOut() {
    this.documentClassList.remove(`font-size--${fontSizes[this.currentFontSize]}`);
    this.currentFontSize--;
    this.documentClassList.add(`font-size--${fontSizes[this.currentFontSize]}`);
    this.userStorage.setItem(accessibilityFontSize, this.currentFontSize.toString());
  }
}
